import { useEffect, useState } from "react";

const EVENT_NAME = "onboarding:tour_state";

function readFromDom() {
  if (typeof document === "undefined") return { active: false, stepId: null };
  const ds = document.documentElement?.dataset || {};
  return {
    active: ds.onboardingTourActive === "true",
    stepId: ds.onboardingTourStepId || null,
  };
}

export function setOnboardingTourState(active, stepId) {
  if (typeof document === "undefined") return;
  const el = document.documentElement;
  if (!el) return;

  if (active) {
    el.dataset.onboardingTourActive = "true";
    if (stepId) el.dataset.onboardingTourStepId = stepId;
    else delete el.dataset.onboardingTourStepId;
  } else {
    delete el.dataset.onboardingTourActive;
    delete el.dataset.onboardingTourStepId;
  }

  window.dispatchEvent(
    new CustomEvent(EVENT_NAME, {
      detail: { active: !!active, stepId: stepId || null },
    }),
  );
}

export function useOnboardingTourState() {
  const [state, setState] = useState(() => readFromDom());

  useEffect(() => {
    const handler = (e) => {
      const next = e?.detail || readFromDom();
      setState(next);
    };
    window.addEventListener(EVENT_NAME, handler);
    // In case something mutated the dataset before we mounted.
    setState(readFromDom());
    return () => window.removeEventListener(EVENT_NAME, handler);
  }, []);

  return state;
}

export function useOnboardingUiEnabled() {
  return useOnboardingTourState().active;
}

